import { EnumOption } from "./enum-option"

export const CompanyContactRole = {
    StandardUser: 0,
    Administrative: 1,
    CompanySigner: 2,
    BillingContact: 4,
    HR: 8,
    Recruit: 16,
    EmployerAdministration: 32,
}

export const CompanyContactRoleList: EnumOption[] = [
    { value: CompanyContactRole.StandardUser, label: 'Standard User' },
    { value: CompanyContactRole.Administrative, label: 'Administrative' },
    { value: CompanyContactRole.CompanySigner, label: 'Company Signer' },
    { value: CompanyContactRole.BillingContact, label: 'Billing Contact' },
    { value: CompanyContactRole.HR, label: 'HR' },
    { value: CompanyContactRole.Recruit, label: 'Recruit' },
    { value: CompanyContactRole.EmployerAdministration , label: 'Employer Portal Admin' },
]
